import React, { useEffect, useState } from 'react';
import CContactDrawer from './components/CContactDrawer';
import IInvestContact from '../../interfaces/contact/IInvestContact';
import { useParams } from 'react-router-dom';
import CContactDrawerAll from './components/CContactDrawerAll';

type InvestorContactDrawerProps = {
	contacts: IInvestContact[];
};
const InvestorContactDrawer = (props: InvestorContactDrawerProps) => {
	const { contacts } = props;

	const routeParams = useParams();

	const [filterContacts, setFilterContacts] = useState<IInvestContact[]>([]);
	useEffect(() => {
		let contactList: IInvestContact[] = [];
		if (contacts && routeParams) {
			// Par défaut le contact est celui ayant expertiseTag à null
			const defaultContact = contacts.find((x) => x.expertiseTag === null);
			const defaultList = defaultContact ? [defaultContact] : [];

			// Si la route contient le tag investExpertiseTag alors on filtre sur les contacts contenant cet expertiseTag
			if (routeParams.investExpertiseTag) {
				const expertContact = contacts.find((x) => x.expertiseTag === routeParams.investExpertiseTag);
				contactList = expertContact ? [expertContact] : defaultList;
			} else {
				const globalContacts = contacts.filter((x) => x.expertiseTag !== null);
				contactList = globalContacts.length > 0 ? globalContacts : defaultList;
			}
		}
		setFilterContacts(contactList);
	}, [contacts, routeParams]);

	return (
		<>
			{filterContacts?.length === 1 ? (
				<CContactDrawer className="investor-contact-drawer-item" contacts={filterContacts} />
			) : (
				<CContactDrawerAll />
			)}
		</>
	);
};

export default InvestorContactDrawer;
